import cx from 'clsx';
import React from 'react';

import GhostTile from '@/components/modular-grid/GhostTile';

import styles from './TopGames.module.scss';

const ghostsFiller = new Array(10).fill(null);

export default function TopGamesGhost() {
  return (
    <div className={cx(styles.layout)}>
      {ghostsFiller.map((_, index) => {
        return (
          <div
            className={cx(styles.counter)}
            data-index={index + 1}
            key={index}
          >
            <GhostTile />
          </div>
        );
      })}
    </div>
  );
}
